
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 17.67a6.67 6.67 0 005.858-3.482M17.67 11A6.67 6.67 0 0011 4.33M11 4.33a6.67 6.67 0 00-5.858 3.481M4.33 11A6.67 6.67 0 0011 17.67M5.142 7.81A6.67 6.67 0 0117.669 11M4.33 11a6.67 6.67 0 0012.528 3.189","stroke":"#CACACA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.5 8h-4V4M13 14.188h3.999v4","stroke":"#CACACA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    